import React, {Component} from 'react';
import {Container, Row, Col, Card, CardHeader, CardBody, InputGroup, InputGroupButton} from 'reactstrap';
import {
  withRouter
} from 'react-router-dom';
import {postData} from '../../../api/doLogin.js';

import 'spinkit/css/spinkit.css';

class Loading extends Component {
  constructor(props) {
    super(props);
    //var _loginID = props.cookies.get('loginID') || 0;
    //var _token = props.mainCtrl.state.token || "";
    //var _expires = props.cookies.get('expiresAt') || 0;
    this.state = {
      token: "",
      errorMsg: "",

    }
    //console.log(props);
  }

  componentDidMount() {
    var self = this;
    //Call Server to get Data
    postData('reauth', {}, this.props.mainCtrl.state.token)
      .then((data) => {
        //console.log(JSON.stringify(data))
        if (data.status === "success") {
          //set cookie and navigate to home page through App Component
          self.props.mainCtrl.reauthSuccess(data.data.id, data.data.token, data.data.expiresAt, data.data.perms, data.data.lmsMenu, function () {

          });
        } else {
          self.props.mainCtrl.reauthError(data.message);
        }
      }) // JSON-string from `response.json()` call
      .catch(error => console.error(error));
  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <div className="clearfix">

                <h4 className="pt-4" style={{textAlign: 'center'}}>Please wait while we load your settings...</h4>
              </div>
              <Card>
                <CardBody>
                  <div className="sk-wave">
                    <div className="sk-rect sk-rect1"></div>
                    &nbsp;
                    <div className="sk-rect sk-rect2"></div>
                    &nbsp;
                    <div className="sk-rect sk-rect3"></div>
                    &nbsp;
                    <div className="sk-rect sk-rect4"></div>
                    &nbsp;
                    <div className="sk-rect sk-rect5"></div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/views/Pages/Loading/Loading.js